import en_US from './en_US'
import zh_HK from './zh_HK'

export const defaultLocale = 'en_US'

export const languages = {
	en_US,
	zh_HK,
}
